/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */
import type {
  GroupEvent,
  GroupEventRead,
  GroupEventRequest,
  GroupsEventsListParams,
  PaginatedGroupEventReadList,
  PatchedGroupEventRequest
} from '../types';

import { apiV2 } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const groupsEventsList = (
    groupId: string,
    params?: GroupsEventsListParams,
 options?: SecondParameter<typeof apiV2<PaginatedGroupEventReadList>>,) => {
      return apiV2<PaginatedGroupEventReadList>(
      {url: `/groups/${groupId}/events/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const groupsEventsCreate = (
    groupId: string,
    groupEventRequest: GroupEventRequest,
 options?: SecondParameter<typeof apiV2<GroupEvent>>,) => {
      return apiV2<GroupEvent>(
      {url: `/groups/${groupId}/events/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: groupEventRequest
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const groupsEventsRetrieve = (
    groupId: string,
    id: string,
 options?: SecondParameter<typeof apiV2<GroupEventRead>>,) => {
      return apiV2<GroupEventRead>(
      {url: `/groups/${groupId}/events/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const groupsEventsPartialUpdate = (
    groupId: string,
    id: string,
    patchedGroupEventRequest?: PatchedGroupEventRequest,
 options?: SecondParameter<typeof apiV2<GroupEvent>>,) => {
      return apiV2<GroupEvent>(
      {url: `/groups/${groupId}/events/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedGroupEventRequest
    },
      options);
    }
  /**
 * Deletes the GroupEvent and the associated CalendarEvent.
 */
export const groupsEventsDestroy = (
    groupId: string,
    id: string,
 options?: SecondParameter<typeof apiV2<void>>,) => {
      return apiV2<void>(
      {url: `/groups/${groupId}/events/${id}/`, method: 'DELETE'
    },
      options);
    }
  export type GroupsEventsListResult = NonNullable<Awaited<ReturnType<typeof groupsEventsList>>>
export type GroupsEventsCreateResult = NonNullable<Awaited<ReturnType<typeof groupsEventsCreate>>>
export type GroupsEventsRetrieveResult = NonNullable<Awaited<ReturnType<typeof groupsEventsRetrieve>>>
export type GroupsEventsPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof groupsEventsPartialUpdate>>>
export type GroupsEventsDestroyResult = NonNullable<Awaited<ReturnType<typeof groupsEventsDestroy>>>
